import { ProcedureRowData } from "../tables/procedure/procedure-rows";
import { FilterOption, appendNotSpecifiedFilterOption } from "./filter-helpers";

/**
 * Create filter options for Procedure data based on actual values
 */
export function createProcedureFilters(rows: ProcedureRowData[]): FilterOption[] {
  const filters: FilterOption[] = [];

  if (!rows || rows.length === 0) {
    return filters;
  }

  // Extract unique types and body regions
  const types = new Set<string>();
  const bodyRegions = new Set<string>();

  rows.forEach(row => {
    if (row.type && row.type !== "-") {
      types.add(row.type);
    }
    if (row.bodyRegion && row.bodyRegion !== "-") {
      bodyRegions.add(row.bodyRegion);
    }
  });

  // Create type filters
  Array.from(types)
    .sort()
    .forEach(type => {
      filters.push({
        label: type,
        groupLabel: "Type",
        value: `type:${type}`,
      });
    });

  // Create body region filters
  Array.from(bodyRegions)
    .sort()
    .forEach(bodyRegion => {
      filters.push({
        label: bodyRegion,
        groupLabel: "Body Region",
        value: `bodyRegion:${bodyRegion}`,
      });
    });

  // Automatically add "Not Specified" for each group
  return appendNotSpecifiedFilterOption(filters);
}
